import { CloseIcon } from 'assets/icons/CloseIcon'
import { Input } from 'components/Input/Input'
import { Modal } from 'components/Modal/Modal'
import { addBreakTemplate, editBreakTemplate } from 'features/breaks/breaksSlice'
import useModalClose from 'hooks/useModalClose'
import { useState } from 'react'
import { useDispatch } from 'react-redux'
import { AppDispatch } from 'store'
import { Button, CursorPointer, Flex } from 'styling/GlobalStyles'
import { TitleText } from 'styling/Typography'
import { IBreakTemplate } from 'types/api/breaksApi.interface'
import useFocusFirstInput from 'utils/useFocusFirstInput'

export const BreakTemplatesModal = ({ closeModal, value }: { closeModal: any, value?: IBreakTemplate }) => {
    const [state, setState] = useState<IBreakTemplate>(value || {
        name: '',
        breaks: [
            { id: new Date().getTime(), durationMinutes: null, order: 1 }
        ]
    })
    const dispatch = useDispatch<AppDispatch>()
    useFocusFirstInput()
    useModalClose(closeModal)

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>, name: string) => {
        setState({ ...state, [name]: e.target.value })
    }

    const handleSave = async () => {
        const resp = await dispatch(value?.id ? editBreakTemplate({ ...state, id: value.id }) : addBreakTemplate(state))
        if (resp.meta.requestStatus === 'fulfilled') {
            closeModal()
        }
    }

    const addBreak = () => {
        setState(prev => ({ ...prev, breaks: [...prev.breaks, { id: new Date().getTime(), durationMinutes: null, order: prev.breaks.length + 1 }] }))
    }

    return <Modal black>
        <Flex column between center >
            <Flex column gap='1rem' width='100%' >
                <Flex between width='100%' center style={{ marginBottom: '1rem' }}>
                    <TitleText weight='bold' >{value?.id ? 'Edit' : 'Add'} Break Template</TitleText>
                    <CursorPointer onClick={closeModal} >
                        <CloseIcon />
                    </CursorPointer>
                </Flex>
                <Input placeholder='Enter template name...' labelText='Name' value={state.name} onChange={e => handleChange(e, 'name')} nomarg />
                {state.breaks.map(b => <Flex width='100%' between key={b.id} >
                    <Input placeholder='Duration in minutes...' labelText={`Break ${b.order} duration (minutes)`} value={b.durationMinutes} onChange={e => setState(prev => ({ ...prev, breaks: prev.breaks.map(br => br.id === b.id ? { ...br, durationMinutes: Number(e.target.value) } : br) }))} nomarg />
                </Flex>)}
                <Flex width='100%' justend >
                    <Button onClick={addBreak} orange >Add Break</Button>
                </Flex>
            </Flex>
            <Button mt='16' orange onClick={handleSave} >Save</Button>
        </Flex>
    </Modal>
}


